import React, { useContext, useEffect, useState } from "react";
import SocketContext from "../../../context/SocketContext";


export default function LTP(props) {
  const socket = useContext(SocketContext);

  const symbol_id = props.symbol_id;

  const [LTP, setLTP] = useState(0);
  const [digit, setDigit] = useState(0);

  useEffect(() => {
    socket.emit("giverate", symbol_id);
    socket.on("trade" + symbol_id, trade);
    return () => {
      socket.off("trade" + symbol_id, trade);
    };
  }, []);

  const trade = (data) => {
    if (data != null) {
      setLTP(data.LTP);
      setDigit(data.digit || 0);
    }
  };

  return <div className={`menuLtp small`}> LTP : {parseFloat(LTP).toFixed(digit)}</div>;
}
